module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forward",
    attrs: {
      "id": "AC_"
    }
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz13-1"
    }
  }, [_c('i', [_vm._v("The gifts he gave were that some would be apostles, some prophets, some evangelists,\n\t\t\t\t\tsome pastors and teachers, to equip the saints for the work of ministry, for building\n\t\t\t\t\tup the body of Christ, until all of us come to the unity of the faith and of the\n\t\t\t\t\tknowledge of the Son of")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "pz13-2"
    }
  }, [_c('i', [_vm._v("God, to maturity, to the measure of the full stature of Christ.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz13-3"
    }
  }, [_vm._v("\n\t\t\t\t\t(Eph. 4:11–13 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NRSV")]), _vm._v(") ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a62361a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter04.vue
// module id = 78
// module chunks = 0